import OneSignal from 'react-onesignal';
import i18next from 'i18next';

type OneSignalInitOptions = Parameters<typeof OneSignal.init>[0];

/**
 * Builds the OneSignal Web SDK init options.
 *
 * `serviceWorkerPath` points to public/OneSignalSDKWorker.js. The push
 * permission is asked via a friendly soft slidedown (autoPrompt: false — we
 * trigger it explicitly after login), with i18n texts.
 */
export function getOneSignalInitOptions(appId: string): OneSignalInitOptions {
  return {
    appId,
    allowLocalhostAsSecureOrigin: true,
    serviceWorkerParam: { scope: '/' },
    serviceWorkerPath: 'OneSignalSDKWorker.js',
    promptOptions: {
      slidedown: {
        prompts: [
          {
            type: 'push',
            autoPrompt: false,
            delay: { pageViews: 1, timeDelay: 0 },
            text: {
              actionMessage: i18next.t('onesignal_prompt_action_message'),
              acceptButton: i18next.t('onesignal_prompt_accept_button'),
              cancelButton: i18next.t('onesignal_prompt_cancel_button')
            }
          }
        ]
      }
    }
  };
}
